import React from 'react';
import Box from '@mui/material/Box';
import MuiPagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  onPageChange: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  totalItems,
  onPageChange,
}) => {
  if (totalItems === 0) return null;

  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}
      aria-label="Phân trang"
      component="nav"
    >
      <MuiPagination
        count={totalPages}
        page={currentPage}
        onChange={(_, page) => onPageChange(page)}
        color="primary"
        showFirstButton
        showLastButton
        renderItem={(item) => (
          <PaginationItem
            {...item}
            aria-label={
              item.type === 'page'
                ? `Trang ${item.page}`
                : item.type === 'previous'
                ? 'Trang trước'
                : item.type === 'next'
                ? 'Trang sau'
                : item.type === 'first'
                ? 'Trang đầu'
                : item.type === 'last'
                ? 'Trang cuối'
                : undefined
            }
          />
        )}
      />
    </Box>
  );
};
